import { getUserConfig } from '../../api/authentication';
import { getConfig } from '../../helpers/config';

const appGlobal = {
  state: {
    clientConfig: {}, // client config to fetch client url
    env: '',
    firebaseEmail: '',
    locale: 'en',
    config: {},
    user: null,
  },

  getters: {
    env: state => state.env,
    config: state => state.config,
  },

  mutations: {
    SET_LOCALE(state, locale) {
      state.locale = locale;
    },
    SET_ENV(state, payload) {
      state.env = payload;
    },
    SET_CLIENT_CONFIG(state, clientConfig) {
      state.clientConfig = clientConfig;
    },
    SET_CLIENT(state, client) {
      state.client = client;
    },
    SET_FIREBASE_EMAIL(state, payload) {
      state.firebaseEmail = payload;
    },
    SET_CONFIG(state, payload) {
      state.config = payload;
    },
    SAVE_USER(state, payload) {
      state.user = payload;
    },
  },

  actions: {
    getConfigFromLS({ commit }) {
      const { config, client, env, clientConfig } = getConfig();
      // console.log(client, env, clientConfig);
      // merge all the mutations later.
      commit('SET_ENV', env);
      commit('SET_CLIENT_CONFIG', clientConfig);
      commit('SET_CLIENT', client);
      commit('SET_CONFIG', config);
    },
    async getClientConfig({ state, commit }) {
      const config = await getUserConfig(state.env, state.client);
      localStorage.setItem(state.client, JSON.stringify(config.data));
      commit('SET_CLIENT_CONFIG', config.data, state.client);
    },
  },
};

export default appGlobal;



// WEBPACK FOOTER //
// ./src/store/modules/appGlobal.js